import React, { PropTypes } from 'react';

export const LOADER_TYPE = {
  SPINNER: 'spinner',
  BAR: 'bar',
};

const renderLoadingSpinner = (() => {
  return (
      <div className='loader'>
        <svg className='circular' viewBox='25 25 50 50'>
          <circle
              className='path' cx='50' cy='50' r='20'
              fill='none' strokeWidth='2' strokeMiterlimit='10'
          />
        </svg>
      </div>
  );
});

const renderLoadingBar = (() => {
  return (
      <div className='load-bar'>
        <div className='bar' />
        <div className='bar' />
      </div>
  );
});

const renderComponent = ((children) => {
  return children || null;
});

const LoadingIndicator = ((props) => {
  const { children, loading, loaderType } = props;
  if (loaderType === LOADER_TYPE.BAR) {
    return (
      <div>
        { loading ? renderLoadingBar() : renderComponent(children) }
      </div>
    );
  }
  return (
    <div>
      { loading ? renderLoadingSpinner() : renderComponent(children) }
    </div>
  );
});

LoadingIndicator.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  loaderType: PropTypes.oneOf([LOADER_TYPE.SPINNER, LOADER_TYPE.BAR]),
};

export default LoadingIndicator;
